import { defineComponent } from 'vue';
import CustomImage from '../../common/custom-image.vue';
import ContentItem from './content-item.vue';
export default defineComponent({
    name: 'CAngielacoquetteContents',
    components: { ContentItem: ContentItem, CustomImage: CustomImage },
    computed: {
        link: function () {
            return 'https://www.google.com/maps/place/%E6%A8%AA%E6%B5%9C%E5%85%AC%E5%9C%92/@35.4582122,139.5151055,16108m/data=!3m1!1e3!4m10!1m2!2m1!1z5qiq5rWc5YWs5ZySIOWcsOWbsw!3m6!1s0x60185cf009f879cf:0xb620378b01a6f329!8m2!3d35.4442082!4d139.6406544!15sChPmqKrmtZzlhazlnJIg5Zyw5ZuzWg8iDeaoqua1nCDlhazlnJKSAQRwYXJrmgEkQ2hkRFNVaE5NRzluUzBWSlEwRm5TVU5QTlc5WGEyaDNSUkFC4AEA!16s%2Fg%2F121873qt?entry=ttu';
        },
        linkIos: function () {
            return 'https://apps.apple.com/jp/app/id6463716168';
        },
        linkAndroid: function () {
            return 'https://play.google.com/store/apps/details?id=com.dena.a12027123';
        }
    }
});
